import React from 'react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: "Frontend Development",
      skills: [
        { name: "React.js", level: 90, icon: "💻" },
        { name: "JavaScript", level: 85, icon: "🔧" },
        { name: "HTML5/CSS3", level: 95, icon: "🎨" },
        { name: "TypeScript", level: 80, icon: "📱" }
      ]
    },
    {
      title: "Backend Development",
      skills: [
        { name: "Node.js", level: 85, icon: "🔋" },
        { name: "PHP", level: 82, icon: "🛠️" },
        { name: "MongoDB", level: 75, icon: "🗄️" },
        { name: "MySQL", level: 80, icon: "📊" }
      ]
    },
    {
      title: "Mobile Development",
      skills: [
        { name: "Flutter", level: 85, icon: "📱" },
        { name: "Dart", level: 80, icon: "🎯" },
        { name: "React Native", level: 85, icon: "📱" },
        { name: "Mobile UI/UX", level: 85, icon: "🎨" },
        { name: "App Publishing", level: 75, icon: "🚀" }
      ]
    },
    {
      title: "CMS & WordPress",
      skills: [
        { name: "WordPress Development", level: 88, icon: "📝" },
        { name: "Theme Customization", level: 85, icon: "🎨" },
        { name: "Plugin Development", level: 82, icon: "🔌" },
        { name: "WooCommerce", level: 80, icon: "🛍️" }
      ]
    },
    {
      title: "DevOps & Tools",
      skills: [
        { name: "Git/GitHub", level: 90, icon: "🔄" },
        { name: "Docker", level: 75, icon: "🐳" },
        { name: "AWS", level: 70, icon: "☁️" },
        { name: "CI/CD", level: 80, icon: "⚡" }
      ]
    }
  ];
  return (
    <section className="skills-section">
      <div className="skills-container">
        <h2 className="section-title">Technical Skills</h2>
        <div className="skills-categories">
          {skillCategories.map((category, index) => (
            <div className="category-card" key={index}>
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div className="skill-item" key={skillIndex}>
                    <div className="skill-header">
                      <span className="skill-icon">{skill.icon}</span>
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div 
                        className="skill-progress" 
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
